
export function genBarXaxisPoints (arr, xKey, { minX, maxX, padding }) {
    arr = arr.map(item => typeof item === 'string' ? item : item[xKey])
    const gridX = (maxX - minX - padding) / (arr.length)
    return arr.map((label, index) => {
        return {
            label,
            x: (index) * gridX + minX
        }
    })
}
export function genLineXaxisPoints (arr, xKey, { minX, maxX, padding }) {
    arr = arr.map(item => typeof item === 'string' ? item : item[xKey])
    const len = arr.length - 1
    const gridX = (maxX - minX - padding) / len
    return arr.map((label, index) => {
        return {
            label,
            x: arr.length === 1 ? (maxX - minX - padding) / 2 : (index) * gridX + minX
        }
    })
}

export function genYaxisPoints ({ yGrid }, { minY, maxY, padding }, { min, max }) {
    if (max === min && min) {
        max += 1
        min -= 1
    }
    const span = max - min
    const yMagic = Math.floor(Math.log(span) / Math.log(10))
    const unit = Math.pow(10, yMagic)
    const grid = []
    let gridMin = Math.floor(min / unit) * unit
    let gridMax = Math.ceil(max / unit) * unit

    gridMin = isNaN(gridMin) ? (min / unit) * unit : gridMin
    gridMax = isNaN(gridMax) ? (max / unit) * unit : gridMax

    let step = (gridMax - gridMin) / (yGrid - 1)
    if (unit === 1 && step > 1 && Math.ceil(step) !== step) {
        step = Math.ceil(step)
        gridMax = gridMin + step * (yGrid - 1)
    }
    if (gridMin < 0 && gridMax > 0) {
        gridMin = Math.floor(min / step) * step
        gridMax = Math.ceil(max / step) * step
    }
    if (min === 0 && max === 0) {
        gridMin = 0
        gridMax = 1
        step = 1 / (yGrid - 1)
    }
    const rate = (maxY - minY) / (gridMax - gridMin)
    if (step < 1) {
        const sMagic = Math.floor(Math.log(step) / Math.log(10))
        for (let i = 0; i < yGrid; i++) {
            grid.push({
                y: parseFloat(i.toFixed(1 - sMagic)) * rate * step,
                label: gridMax - (parseFloat(i.toFixed(1 - sMagic)) * step)
            })
        }
    } else {
        for (let i = 0; i < yGrid; i++) {
            grid.push({
                y: i * rate * step,
                label: gridMax - (i * step)
            })
        }
    }
    return grid
}
